<!--
 * @Description: 
 * @Autor: wangzh
 * @Date: 2021-05-07 12:51:40
 * @LastEditTime: 2021-07-13 14:13:43
-->
<template>
	<div id="app">
		<!-- <div id="nav"> -->
		<!-- <router-link to="/">Home</router-link> |
		<router-link to="/about">About</router-link>-->
		<!-- </div> -->
		<router-view />
	</div>
</template>
<script>
export default {
	watch: {
		// 监听路由变化
		$route(to, from) {
			document.title = to.name;
		},
	},
};
</script>

<style lang="scss">
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
}
.van-dialog__content--isolated {
	min-height: 75px !important;
}
#nav {
	padding: 30px;

	a {
		font-weight: bold;
		color: #2c3e50;

		&.router-link-exact-active {
			color: #42b983;
		}
	}
}
</style>
